// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1U2WO","left":"StickyBox_left__17pz9","right":"StickyBox_right__rlMII"};